export const EDITOR_TABLE_ADD_COLUMN_WITH_CUSTOM_STEP =
	'confluence.frontend.fabric.editor.add-column-custom-step';
export const EDITOR_TABLE_ENABLE_STICKY_TABLE_HEADERS =
	'confluence.frontend.fabric.editor.enable-sticky-table-headers';
export const EDITOR_VIEW_CONNECT_MACRO_AS_FORGE = 'confluence.frontend.connect.macro.view-as-forge';
export const EDITOR_SAVE_CONNECT_MACRO_AS_FORGE = 'confluence.frontend.connect.macro.save-as-forge';
export const EDITOR_MACRO_ADF_RENDERING =
	'confluence.frontend.fabric.editor.macro.adf.frontend.render';
export const EDITOR_PRELOAD_DRAFT_CONTENT =
	'confluence.frontend.preload.draft.body.content.next.editor';
export const EDITOR_PLUGIN_AI_FEATURE_FLAG = 'confluence.frontend.fabric.editor.editor-plugin-ai';
export const EDITOR_ENABLE_AI_UPSELL = 'platform.ai.enable-ai-upsell';
